<template>
    <div>
        <div class="row mb-3">
            <div class="col-12">
                <div class="ibox">
                    <div class="ibox-content">
                        <vue-good-table :columns="columns" :rows="rows" row-style-class="fs-10px" mode="remote"
                            @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :isLoading.sync="isLoading"
                            :pagination-options="{
                                enabled: true,
                            }">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'value'">
                                    {{ parseInt(props.row.amount) * props.row.price }}
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>    
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import appService from '@/apis/appService';

export default {
    components: {
        VueGoodTable,
    },
    data() {
        return {
            rows: [],
            columns: [
                {
                    label: 'Bizonylatszám',
                    field: 'p_inventory_id',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Raktárhelyazonosító',
                    field: 'lth_id',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Vonalkód',
                    field: 'barcode',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Cikkszám',
                    field: 'foreign_id',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Megnevezés',
                    field: 'name',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Egységár',
                    field: 'price',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Mennyiség',
                    field: 'amount',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Érték',
                    field: 'value',
                    thClass: 'fs-10px',
                    sortable: false,
                    filterOptions: {
                        enabled: false,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Egység',
                    field: 'unit',
                    thClass: 'fs-10px',
                    sortable: false,
                    filterOptions: {
                        enabled: false,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Lszsz',
                    field: 'lszsz',
                    thClass: 'fs-10px',
                    width: '80px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Szektor',
                    field: 'control',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
            ],
            isLoading: false,
            totalRecords:10,
            serverParams: {
                columnFilters: {
                },
                sort: {
                    field: '',
                    type: '',
                },
                page: 1,
                perPage: 10
            }
        }
    },
    computed: {
        lszsz() {
            return this.$store.state.lszsz;
        },
        user() {
            return this.$store.state.user;
        },
    },
    created() {
        this.loadItems();
        this.$store.commit('updateSubTitle', 'Rögzített tételek');
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.loadItems();
        },
        onSortChange(params) {
            console.log(params);
            this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
            this.loadItems();
        },
        onColumnFilter(params) {
            this.updateParams(params);
            this.serverParams.page = 1;
            this.serverParams.currentPage = 1;
            this.loadItems();
        },
        setLoading(value) {
            this.isLoading = value;
        },
        loadItems() {
            this.setLoading(true);
            appService.getRecordedItems(this.user.project_id, this.lszsz, appService.getDeviceId(), this.serverParams).then(response => {
                this.updateParams({
                    currentPage: response.data.actualPage,
                    page: response.data.actualPage,
                    perPage: response.data.perPage,
                });
                this.totalRecords = response.data.total;
                this.rows = response.data.data;
            }).finally(() => {
                this.setLoading(false);
            })
            /* 
            this.rows = [
                { receipt_number: '0001', place_barcode: 'R00000001', barcode: '0000000000001', article_number: '342', name: 'KLAIFORNIAI PAPRIKA', price: '1299', quantity: '1', value: '1299', unit: 'db', lszsz: '167', sector: '1240' },
                { receipt_number: '0001', place_barcode: 'R00000001', barcode: '0000000000001', article_number: '342', name: 'KLAIFORNIAI PAPRIKA', price: '1299', quantity: '1', value: '1299', unit: 'db', lszsz: '167', sector: '1240' },
                { receipt_number: '0001', place_barcode: 'R00000001', barcode: '0000000000001', article_number: '342', name: 'KLAIFORNIAI PAPRIKA', price: '1299', quantity: '1', value: '1299', unit: 'db', lszsz: '167', sector: '1240' },
                { receipt_number: '0001', place_barcode: 'R00000001', barcode: '0000000000001', article_number: '342', name: 'KLAIFORNIAI PAPRIKA', price: '1299', quantity: '1', value: '1299', unit: 'db', lszsz: '167', sector: '1240' },
                { receipt_number: '0001', place_barcode: 'R00000001', barcode: '0000000000001', article_number: '342', name: 'KLAIFORNIAI PAPRIKA', price: '1299', quantity: '1', value: '1299', unit: 'db', lszsz: '167', sector: '1240' },
            ]
            */
        }
    }
}
</script>